"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainAisle = mapToDomainAisle;
function mapToDomainAisle(dto) {
    return {
        micronProductId: dto.micronProductId,
        productCustomCode: dto.productCustomCode,
        weight: dto.weight,
        productName: dto.productName,
        isEnable: dto.isEnable,
        imgUrl: dto.imgUrl,
        currStock: dto.currStock,
        productCode: dto.productCode,
        aisleCode: dto.aisleCode,
        price: dto.price,
        micronAisleId: dto.micronAisleId,
        maxStock: dto.maxStock,
        aisleName: dto.aisleName,
        currency: dto.currency,
        isBroken: dto.isBroken,
        thumbnailUrl: dto.thumbnailUrl,
    };
}
